//////////
// ROOT //
//////////
export const RESET_STATE = 'RESET_STATE'
export const PROCESS_API_SUCCESS = 'PROCESS_API_SUCCESS'
export const PROCESS_API_FAILURE = 'PROCESS_API_FAILURE'

export * from './mutation-types1'
